"use client";

import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import ProfilePic from "../assets/images/profilepic.png";
import CustomButton from "./CustomButton";
import DropdownMenu from "./Dropdown";
import { Icon } from "@iconify/react/dist/iconify.js";

export default function ProfileDrawer({ open, setOpen }) {
  const menuItems = [
    { label: "View Profile", href: "#" },
    { label: "Copy Profile Link", href: "#" },
  ];
  return (
    <Dialog open={open} onClose={setOpen} className="relative z-50">
      {/* Transparent overlay */}
      <div className="fixed inset-0 bg-transparent bg-opacity-40 backdrop-blur-sm backdrop-filter transition-opacity duration-500 ease-in-out" />

      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
            <DialogPanel
              transition
              className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
            >
              <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                <div className="px-4 sm:px-6">
                  <div className="flex items-start justify-between">
                    <DialogTitle className="text-base font-semibold text-gray-900">
                      Profile
                    </DialogTitle>
                    <div className="ml-3 flex h-7 items-center">
                      <button
                        type="button"
                        onClick={() => setOpen(false)}
                        className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      >
                        <span className="absolute -inset-2.5" />
                        <span className="sr-only">Close panel</span>
                        <XMarkIcon aria-hidden="true" className="size-6" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="relative mt-6 flex-1">
                  {/* Your content */}
                  <div className="bg-gray-400 px-4 sm:px-6">
                    <div className="h-36"></div>
                  </div>
                  <div className="rounded-lg px-4 sm:px-6 mt-[-110px]">
                    <img src={ProfilePic} className="w-36 h-36 rounded-full" />
                  </div>
                  <div className="mt-5 px-4 sm:px-6">
                    <h1 className="text-2xl font-semibold ">
                      Anthea Dransfield <span></span>
                    </h1>
                    <a href="#" className="text-sm text-gray-500">
                      linkedin.com/in/antheadransfield
                    </a>
                  </div>
                  <div className="flex items-center justify-between mt-3 px-4 sm:px-6">
                    <CustomButton
                      color={"bg-indigo-600"}
                      size={"text-base"}
                      weight={"font-normal"}
                      height={"h-9"}
                      width={"w-40"}
                      textColor={"text-white"}
                      text={"Message"}
                    />
                    <CustomButton
                      color={"bg-white"}
                      size={"text-base"}
                      weight={"font-normal"}
                      height={"h-9"}
                      width={"w-40"}
                      textColor={"text-black"}
                      text={"Email"}
                      border={"border border-gray-300"}
                    />
                    <DropdownMenu
                      menuItems={menuItems}
                      icon={true}
                      buttonLabel={"Manage"}
                      border={"border border-gray-300"}
                    />
                  </div>

                  <div className="px-4 sm:px-6">
                    <div className="mt-5">
                      <h3 className="text-gray-500 font-semibold text-sm">
                        Title
                      </h3>
                      <p className="text-sm">Head of Quality</p>
                    </div>
                    <div className="mt-5">
                      <h3 className="text-gray-500 font-semibold text-sm">
                        Bio
                      </h3>
                      <p className="text-sm">
                        Anthea has spent over 30 years in the life sciences
                        industry encompassing experience in operations and
                        quality across cGMP, GCP, GCLP and CSV. She has led over
                        one hundred audits including qualification,
                        re-qualification, in-study, directed and for-cause. She
                        is currently the Head of Quality at Diligent Pharma,
                        leading a talented group of internal and external
                        auditors spanning the globe.
                      </p>
                    </div>
                    <div className="mt-5">
                      <h3 className="text-gray-500 font-semibold text-sm">
                        Location
                      </h3>
                      <p className="text-sm">Spring Hill, TN, USA</p>
                    </div>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
